import React, { useEffect, useMemo, useState } from 'react';
import { TopNav } from '../components/TopNav';
import { ExpansionMap } from '../components/ViralityRadar';
import { getMapData, createMapEntity, deleteMapEntity } from '@/services/map';

interface PageProps { theme: string; toggleTheme: () => void }

const MapPage: React.FC<PageProps> = ({ theme, toggleTheme }) => {
  const [data, setData] = useState<any>({});
  const [form, setForm] = useState<any>({ city: 'new_york', type: 'artist', status: 'active', name: '', lat: '', lng: '' });
  useEffect(() => { (async () => { try { setData(await getMapData()); } catch {} })(); }, []);
  const flat = useMemo(()=> Object.entries<any>(data).flatMap(([city, val]) => (val?.entities||[]).map((e:any)=>({ city, ...e }))), [data]);
  return (
    <div className="min-h-screen bg-body">
      <TopNav theme={theme} toggleTheme={toggleTheme} />
      <main className="max-w-7xl mx-auto p-3 md:p-4">
        <h1 className="text-xl font-extrabold text-primary mb-3">Mapa de Expansão</h1>
        <p className="text-sm text-muted mb-4">Camada principal com pontos, conexões e indicadores locais.</p>
        <div className="bg-white dark:bg-[#181818] border border-zinc-200 dark:border-zinc-800 rounded-lg p-3 mb-4 grid grid-cols-1 md:grid-cols-6 gap-2 items-end">
          <div>
            <label className="text-xs text-muted">Cidade</label>
            <select className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={form.city} onChange={e=>setForm((p:any)=>({...p, city:e.target.value }))}>
              {['new_york','paris','las_vegas','miami'].map(c=> <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label className="text-xs text-muted">Tipo</label>
            <select className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={form.type} onChange={e=>setForm((p:any)=>({...p, type:e.target.value }))}>
              {['artist','brand','office','event'].map(t=> <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div>
            <label className="text-xs text-muted">Status</label>
            <select className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={form.status} onChange={e=>setForm((p:any)=>({...p, status:e.target.value }))}>
              {['active','negotiation','planned','risk'].map(s=> <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="md:col-span-3">
            <label className="text-xs text-muted">Nome</label>
            <input className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={form.name} onChange={e=>setForm((p:any)=>({...p, name:e.target.value }))}/>
          </div>
          <div>
            <label className="text-xs text-muted">Lat</label>
            <input className="w-full px-3 py-2 rounded-md border" value={form.lat} onChange={e=>setForm((p:any)=>({...p, lat:e.target.value }))}/>
          </div>
          <div>
            <label className="text-xs text-muted">Lng</label>
            <input className="w-full px-3 py-2 rounded-md border" value={form.lng} onChange={e=>setForm((p:any)=>({...p, lng:e.target.value }))}/>
          </div>
          <button className="md:col-span-4 px-3 py-2 rounded-md bg-zinc-900 text-white dark:bg-green-500 dark:text-black" onClick={async()=>{
            if(!form.name) return;
            const payload: any = { city: form.city, type: form.type, status: form.status, name: form.name };
            if (form.lat && form.lng) payload.latlng = { lat: Number(form.lat), lng: Number(form.lng) };
            await createMapEntity(payload);
            setForm({ city: form.city, type: 'artist', status: 'active', name: '', lat: '', lng: '' });
            setData(await getMapData());
          }}>Adicionar ponto</button>
        </div>
        <ExpansionMap data={data} />
        {flat.length>0 && (
          <div className="mt-3 text-sm bg-white/70 dark:bg-black/30 rounded-lg border border-default p-3">
            <p className="font-semibold mb-2">Entidades (admin)</p>
            <ul className="space-y-1">
              {flat.slice(0,30).map((e:any)=> (
                <li key={e.id} className="flex items-center justify-between">
                  <span className="text-muted truncate mr-2">[{e.city}] {e.name} — {e.type}/{e.status}</span>
                  <button className="text-red-500 text-xs" onClick={async()=>{ await deleteMapEntity(e.id); setData(await getMapData()); }}>excluir</button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </main>
    </div>
  );
};

export default MapPage;

